export default __webpack_public_path__ + "static/media/wyomingValleyMotors.26bbf117.jpg";